import CloseIcon from '@mui/icons-material/Close';
import { MouseEventHandler } from 'react';

import { useTranslate } from '../../../hooks/useTranslate';
import { Button } from '../Button';

type Props = {
  onClick: MouseEventHandler<HTMLButtonElement>;
};

export const CloseButton = ({ onClick, ...rest }: Props) => {
  const { t } = useTranslate();

  return (
    <Button
      variant="secondary"
      format="icon"
      onClick={onClick}
      aria-label={t('close')}
      {...rest}
    >
      <CloseIcon />
    </Button>
  );
};
